import React, { type HTMLAttributes, type Ref } from 'react';
import { EditorSelectedElementProvider } from 'packages/contexts/EditorSelectedElementContext';
import RightSideMenu from '.';
import { InspectorPanel } from './container.styled';

const RightSideMenuContainer = React.forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>((props, ref) => (
    <InspectorPanel ref={ref} {...props}>
        <EditorSelectedElementProvider>
            <RightSideMenu />
        </EditorSelectedElementProvider>
    </InspectorPanel>
));

export default RightSideMenuContainer;
